import { TAppState } from '../../types/appState';
import { EAgentAccountType } from '../../types/userData';

export const isMasterSelector = (state: TAppState) => {
  const { isAuthenticated, agentAccountType } = state.user;

  return isAuthenticated && agentAccountType === EAgentAccountType.Agency;
};
